import restClient from "../restClient";

export const getCalculuses = async (search, status, page, pageSize, location, act_type, options = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: options.signal,
    };
    const params = { page, pageSize, search, location };
    if (status && status.length > 0) {
      params.status = Array.isArray(status) ? status : status;
    }
    if (act_type) {
      params.act_type = act_type;
    }
    const response = await restClient.get(`calculuses`, { ...config, params });
    return response.data;
  } catch (err) {
    console.log(err);
  }
};


export const getWorkingCalculuses = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`calculuses?status=working`, { ...config });
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getCalculusDetail = async (id, tab, tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        type: tab ? tab.toLowerCase().replace(/\s+/g, '-') : undefined,
        tenant: tenantId
      }
    };
    const response = await restClient.get(`calculuses/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createCalculus = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`calculuses`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateCalculus = async (id, data, tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        tenant: tenantId
      }
    };
    const response = await restClient.put(`calculuses/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteCalculus = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`calculuses/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const printCalculus = async (bookingId, documents) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob' // Expecting a PDF file
    };
    const response = await restClient.post(`calculus/ecabinet-viewer`, { booking_id: bookingId, documents }, config);

    return response; // Return the whole response to access headers if needed
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const sendAccountSMS = async (calculusId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`sms-service/accounts/send`, {
      calculusId,
      messageType: 'approval_request'
    }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const chargeOffCalculus = async (calculusId, data = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`calculus/charge-off`, { calculus: calculusId, ...data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const reverseChargeOffCalculus = async (calculusId, data = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(
      `calculus/charge-off-reversal`,
      { calculus: calculusId, ...data },
      config
    );
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
